module.exports = __webpack_public_path__ + "img/mis-logo.434248ec.png";